import React, { useState } from 'react';
import clsx from 'clsx';
import { useCookies } from 'react-cookie';
import Icon from '../../Icon';
import { RetailerPickerItem } from '../types/RetailerItemsPicker';

const RetailerTypeHeaderDropdown = ({
  options,
  selectedOption,
  currentRegionUrl,
}: {
  currentRegionUrl: string;
  selectedOption: RetailerPickerItem;
  options: RetailerPickerItem[];
}) => {
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [_, setCookie] = useCookies([]);

  function handleClick(e, startPageCookieValue) {
    e.preventDefault();
    setCookie('sp', startPageCookieValue, { path: '/', maxAge: 31536000 });
    window.location.href = `${currentRegionUrl}`;
  }

  return options ? (
    <div
      className={clsx('relative hidden flex-none cursor-pointer lg:block')}
      onBlur={() => setDropdownOpen(false)}
      tabIndex={1}
    >
      <div
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className="flex items-center gap-0.5 text-topBarText"
      >
        {selectedOption.displayName}
        <Icon
          name="caret-down"
          className={clsx(
            dropdownOpen && 'rotate-180',
            'transition-transform'
          )}
        />
      </div>
      {dropdownOpen && (
        <ul className="absolute right-0 top-full z-10 mt-2 min-w-full whitespace-nowrap border border-solid border-black bg-gray-800 text-white">
          {options?.map((option) => (
            <li
              className="flex items-center gap-2 bg-gray-800 p-1.5 px-2 text-md hover:bg-gray-700"
              key={option.code}
              onClick={(e) => handleClick(e, option.code)}
            >
              {option.displayName}
            </li>
          ))}
        </ul>
      )}
    </div>
  ) : null;
};

export default RetailerTypeHeaderDropdown;
